import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';

const RequireProfileAdmin = ({ children, redirectTo = '/openplay/event' }) => {
  const location = useLocation();
  const [status, setStatus] = useState({ loading: true, authed: false, allowed: false });
  const [warned, setWarned] = useState(false);

  useEffect(() => {
    let mounted = true;

    const check = async () => {
      try {
        const { data, error } = await supabase.auth.getSession();
        if (!mounted) return;
        if (error || !data?.session?.user?.id) {
          setStatus({ loading: false, authed: false, allowed: false });
          return;
        }

        const userId = data.session.user.id;

        const { data: profile, error: profileError } = await supabase
          .from('profiles')
          .select('role')
          .eq('id', userId)
          .maybeSingle();

        if (!mounted) return;
        if (profileError) {
          setStatus({ loading: false, authed: true, allowed: false });
          return;
        }

        setStatus({ loading: false, authed: true, allowed: profile?.role === 'admin' });
      } catch {
        if (!mounted) return;
        setStatus({ loading: false, authed: false, allowed: false });
      }
    };

    check();

    const { data: sub } = supabase.auth.onAuthStateChange(() => {
      check();
    });

    return () => {
      mounted = false;
      sub?.subscription?.unsubscribe?.();
    };
  }, []);

  useEffect(() => {
    if (status.loading) return;
    if (!status.authed) return;
    if (status.allowed) return;
    if (warned) return;

    setWarned(true);
    window.alert('관리자만 접근할 수 있습니다.');
  }, [status, warned]);

  if (status.loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-sm text-muted-foreground">로딩 중...</div>
      </div>
    );
  }

  if (!status.authed) {
    return <Navigate to="/openplay/user-authentication" replace state={{ from: location?.pathname }} />;
  }

  if (!status.allowed) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default RequireProfileAdmin;
